import { createStyles, makeStyles } from '@hawkins/styles';
export var cardBodyStyles = function (theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name to apply to the root of the component */
        root: {
            color: hawkins.textColor.textColorRegular,
            overflow: 'auto',
            fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
            padding: "".concat(hawkinsVariables.spacings.space4, " ").concat(hawkinsVariables.spacings.space4, " ").concat(hawkinsVariables.spacings.space4, " ").concat(hawkinsVariables.spacings.space4),
        },
        /** Class name to apply when 'fullScreen' is true */
        rootFullScreen: {
            margin: " 0 -".concat(hawkinsVariables.spacings.space3),
            padding: "".concat(hawkinsVariables.spacings.space3, " ").concat(hawkinsVariables.spacings.space3, " 0 ").concat(hawkinsVariables.spacings.space3),
            overflow: 'auto',
            flex: 1,
        },
        /** Class name to apply when `square` is true */
        rootSquare: {},
    });
};
export var useCardBodyStyles = makeStyles(cardBodyStyles, { name: 'Hawkins-CardBody' });
